'use client'

import { Text, Bubble } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  inverse: boolean
  aria?: React.AriaAttributes
}

const DeletedMessage = ({ inverse, aria }: Props) => {
  const translate = useTranslate('conversation.delete_message')

  return (
    <Bubble inverse={inverse}>
      <Text as="span" theme="muted" aria={aria} testId="deleted-message">
        {translate('message_deleted')}
      </Text>
    </Bubble>
  )
}

export default DeletedMessage
